module.exports = __webpack_public_path__ + "img/videoPoster.3d8dfe46.jpg";